export const PhoneIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      {...props}
    >
      <g>
        <path
          d="M23 20.5556V18.5439C23 17.5443 22.3915 16.6455 21.4634 16.2742L18.9772 15.2798C17.7968 14.8076 16.4516 15.3191 15.883 16.4562L15.6667 16.8889C15.6667 16.8889 12.6111 16.2778 10.1667 13.8333C7.72222 11.3889 7.11111 8.33333 7.11111 8.33333L7.5438 8.11699C8.68091 7.54843 9.19238 6.20317 8.72022 5.02277L7.72575 2.5366C7.35453 1.60855 6.45569 1 5.45614 1H3.44444C2.09442 1 1 2.09441 1 3.44444C1 14.2447 9.75532 23 20.5556 23C21.9056 23 23 21.9056 23 20.5556Z"
          strokeWidth="2"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
